"use client";

import Link, { useLinkStatus } from "next/link";
import type { ReactNode } from "react";
import { NavigationMenu } from "@app-foundation/navigation-ui";
import "@app-foundation/navigation-ui/navigation.css";
import styles from "./SidebarNavigation.module.css";

type Item = { href: string; label: string; icon?: ReactNode };
export function SidebarNavigation({ label, groups, active, collapsed = false, onNavigate }: {
  label: string; groups: { label?: string; items: Item[] }[]; active: string;
  collapsed?: boolean; onNavigate?: () => void;
}) {
  return <div className={styles.navigation}>
    {groups.map((group, index) => <div key={group.label ?? index} className={styles.group}>
      {group.label && <h2 className={styles.heading}>{group.label}</h2>}
      <NavigationMenu label={group.label ?? label} collapsed={collapsed} onNavigate={onNavigate}
        items={group.items.map(item => ({ ...item, id: item.href, icon: item.icon ?? null, active: item.href === active }))}
        renderLink={({ children, className, ...props }) => <Link {...props} prefetch={true} className={`${className} ${styles.link}`}>{children}<Pending /></Link>} />
    </div>)}
  </div>;
}
function Pending() {
  const { pending } = useLinkStatus();
  return pending ? <span className="sr-only" role="status">正在打开页面</span> : null;
}
